/**
 * Formats remaining time in a human-readable format
 * @param {number} seconds - Remaining time in seconds
 * @returns {string} Formatted time string
 */
export const formatTimeRemaining = (seconds) => {
  if (seconds <= 0) return 'Now';
  
  const days = Math.floor(seconds / (3600 * 24));
  const hours = Math.floor((seconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m ${secs}s`;
  return `${secs}s`;
};

/**
 * Checks if a listing can be cancelled based on the listedAt timestamp
 * @param {number|string} listedAt - Timestamp when the NFT was listed
 * @returns {{canCancel: boolean, timeRemaining: number, timeRemainingText: string}}
 */
export const checkCancelEligibility = (listedAt) => {
  const THIRTY_DAYS = 30 * 24 * 60 * 60; // 30 days in seconds
  const now = Math.floor(Date.now() / 1000);
  const listedTime = typeof listedAt === 'string' ? parseInt(listedAt) : listedAt;
  const timeElapsed = now - listedTime;
  const timeRemaining = THIRTY_DAYS - timeElapsed;
  
  return {
    canCancel: timeElapsed >= THIRTY_DAYS,
    timeRemaining: Math.max(0, timeRemaining),
    timeRemainingText: formatTimeRemaining(timeRemaining)
  };
};
